export let countries = ['Afganistán',
  'Åland, Islas',
  'Albania',
  'Alemania',
  'Andorra',
  'Angola',
  'Anguila',
  'Antártida',
  'Antigua y Barbuda',
  'Arabia Saudita',
  'Argelia',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaiyán',
  'Bahamas (Las)',
  'Bahrein',
  'Bangladesh',
  'Barbados',
  'Belarús',
  'Bélgica',
  'Belice',
  'Benin',
  'Bermudas',
  'Bhután',
  'Bolivia (Estado Plurinacional de)',
  'Bonaire, San Eustaquio y Saba',
  'Bosnia y Herzegovina',
  'Botswana',
  'Bouvet, Isla',
  'Brasil',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Caimán, (Las) Islas',
  'Camboya',
  'Camerún',
  'Canadá',
  'Chad',
  'Chequia',
  'Chile',
  'China',
  'Chipre',
  'Cocos / Keeling, (Las) Islas',
  'Colombia',
  'Comoras (Las)',
  'Congo (El)',
  'Congo (La República Democrática del)',
  'Cook, (Las) Islas',
  'Corea (La República de)',
  'Corea (La República Popular Democrática de)',
  'Costa Rica',
  'Côte d\' Ivoire',
  'Croacia',
  'Cuba',
  'Curaçao',
  'Dinamarca',
  'Djibouti',
  'Dominica',
  'Ecuador',
  'Egipto',
  'El Salvador',
  'Emiratos Árabes Unidos (los)',
  'Eritrea',
  'Eslovaquia',
  'Eslovenia',
  'España',
  'Estados Unidos de América (los)',
  'Estonia',
  'Etiopía',
  'Feroe, (Las) Islas',
  'Fiji',
  'Filipinas (Las)',
  'Finlandia',
  'Francia',
  'Gabón',
  'Gambia (La)',
  'Georgia',
  'Georgia del Sur (La) y las Islas Sandwich del Sur',
  'Ghana',
  'Gibraltar',
  'Granada',
  'Grecia',
  'Groenlandia',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guayana Francesa',
  'Guernsey',
  'Guinea',
  'Guinea Bissau',
  'Guinea Ecuatorial',
  'Guyana',
  'Haití',
  'Heard (Isla) e Islas McDonald',
  'Honduras',
  'Hong Kong',
  'Hungría',
  'India',
  'Indonesia',
  'Irán (República Islámica de)',
  'Iraq',
  'Irlanda',
  'Isla de Man',
  'Islandia',
  'Islas Ultramarinas Menores de los Estados Unidos (Las)',
  'Israel',
  'Italia',
  'Jamaica',
  'Japón',
  'Jersey',
  'Jordania',
  'Kazajstán',
  'Kenya',
  'Kirguistán',
  'Kiribati',
  'Kuwait',
  'Lao, (La) República Democrática Popular',
  'Lesotho',
  'Letonia',
  'Líbano',
  'Liberia',
  'Libia',
  'Liechtenstein',
  'Lituania',
  'Luxemburgo',
  'Macao',
  'Macedonia (La ex República Yugoslava de)',
  'Madagascar',
  'Malasia',
  'Malawi',
  'Maldivas',
  'Malí',
  'Malta',
  'Malvinas [Falkland], (Las) Islas',
  'Marianas del Norte, (Las) Islas',
  'Marruecos',
  'Marshall, (Las) Islas',
  'Martinique',
  'Mauricio',
  'Mauritania',
  'Mayotte',
  'México',
  'Micronesia (Estados Federados de)',
  'Moldova (La República de)',
  'Mónaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Navidad, Isla de',
  'Nepal',
  'Nicaragua',
  'Níger (El)',
  'Nigeria',
  'Niue',
  'Norfolk, Isla',
  'Noruega',
  'Nueva Caledonia',
  'Nueva Zelandia',
  'Omán',
  'Países Bajos (los)',
  'Pakistán',
  'Palau',
  'Palestina, Estado de',
  'Panamá',
  'Papua Nueva Guinea',
  'Paraguay',
  'Perú',
  'Pitcairn',
  'Polinesia Francesa',
  'Polonia',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reino Unido de Gran Bretaña e Irlanda del Norte (El)',
  'República Árabe Siria',
  'República Centroafricana (La)',
  'República Dominicana',
  'Reunión',
  'Rumania',
  'Rusia, (La) Federación de',
  'Rwanda',
  'Sahara Occidental',
  'Saint Barthélemy',
  'Saint Kitts y Nevis',
  'Saint Martin (parte francesa)',
  'Salomón, Islas',
  'Samoa',
  'Samoa Americana',
  'San Marino',
  'San Pedro y Miquelón',
  'San Vicente y las Granadinas',
  'Santa Helena, Ascensión y Tristán de Acuña',
  'Santa Lucía',
  'Santa Sede (La)',
  'Santo Tomé y Príncipe',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra leona',
  'Singapur',
  'Sint Maarten (parte neerlandesa)',
  'Somalia',
  'Sri Lanka',
  'Sudáfrica',
  'Sudán (El)',
  'Sudán del Sur',
  'Suecia',
  'Suiza',
  'Suriname',
  'Svalbard y Jan Mayen',
  'Swazilandia',
  'Tailandia',
  'Taiwán (Provincia de China)',
  'Tanzania, República Unida de',
  'Tayikistán',
  'Territorio Británico del Océano Índico (El)',
  'Tierras Australes Francesas (Las)',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad y Tabago',
  'Túnez',
  'Turcas y Caicos, (Las) Islas',
  'Turkmenistán',
  'Turquía',
  'Tuvalu',
  'Ucrania',
  'Uganda',
  'Uruguay',
  'Uzbekistán',
  'Vanuatu',
  'Venezuela (República Bolivariana de)',
  'Viet Nam',
  'Vírgenes británicas, Islas',
  'Vírgenes de los Estados Unidos, Islas',
  'Wallis y Futuna',
  'Yemen',
  'Zambia',
  'Zimbabwe'
]
